var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset",class:_vm.computedClass},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }